import React from "react";
import { useNavigate } from "react-router-dom";
import "./Services.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenNib,
  faLaptopCode,
  faMagnifyingGlass,
  faRocket,
  faShareNodes,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";

const Services = () => {
  const navigate = useNavigate();

  const services = [
    {
      id: "ui-ux-design",
      icon: faPenNib,
      title: "UI / UX & Website Design",
      desc:
        "Clear, intuitive interfaces that build trust and guide users to act—from first click to conversion.",
    },
    {
      id: "web-development",
      icon: faLaptopCode,
      title: "Website & App Development",
      desc:
        "Fast, accessible builds that scale. We focus on performance and maintainability so your product grows with you.",
    },
    {
      id: "search-engine-optimization",
      icon: faMagnifyingGlass,
      title: "SEO & Search Visibility",
      desc:
        "Structure, content, and technical foundations that help search engines understand and rank your site.",
    },
    {
      id: "social-media-marketing",
      icon: faShareNodes,
      title: "Social Media Marketing",
      desc:
        "Consistent content and messaging that strengthen your brand and build lasting audience engagement.",
    },
    {
      id: "search-engine-marketing",
      icon: faRocket,
      title: "Paid Ads & Lead Generation",
      desc:
        "Focused campaigns built on clear targeting, testing, and measurable outcomes—so you know what works.",
    },
    {
      id: "local-business-growth",
      icon: faLocationDot,
      title: "Local Business Growth",
      desc:
        "Local visibility so nearby customers can find, trust, and contact your business when it matters.",
    },
  ];

  return (
    <section className="about-services" aria-label="Our services">
      <div className="about-services-wrap">
        <header className="about-services-head">
          <span className="about-services-kicker">What we do</span>
          <h2>Services that support your growth</h2>
          <p>
            From strategy and design to development and marketing—we help at every stage so your business stays clear, visible, and converting.
          </p>
        </header>

        <div className="about-services-list">
          {services.map((s) => (
            <article
              key={s.id}
              className="about-services-item"
              onClick={() => navigate(`/services/${s.id}`)}
              tabIndex={0}
              role="button"
            >
              <div className="about-services-icon">
                <FontAwesomeIcon icon={s.icon} />
              </div>

              <div className="about-services-content">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
